import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEMONE
import BaseMixer from "../../BaseMixer";
import simplebar from "simplebar-vue";
import { interpret } from "xstate";
import Loader from "@/components/widgets/loader.vue";
import projectImpedimentMachine from "../machines/projectImpedimentMachine";
import { ProjectModule } from "@/store/modules/project.module";
import { ProjectImpedimentModel } from "@/store/models/project/projectImpedimentDTO";
import { Guid } from "guid-typescript";
import DeleteComponent from "@/components/deleteComponent.vue";
let ProjectImpedimentComponent = /** @class */ (() => {
    let ProjectImpedimentComponent = class ProjectImpedimentComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.impediment = "";
            this.newImpediment = new ProjectImpedimentModel();
            this.machine = projectImpedimentMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        send(event) {
            this.machineService.send(event);
        }
        showModal() {
            this.GetImpediments();
            this.$bvModal.show("project-impediments");
        }
        GetImpediments() {
            this.send({ type: "GET_IMPEDIMENTS", projectId: this.projectId.value });
        }
        closeModal() {
            this.impediment = "";
            this.$bvModal.hide("project-impediments");
            this.send({ type: "MAKE_MODAL_DORMANT" });
        }
        PostImpediment() {
            if (!this.impediment.trim()) {
                return;
            }
            this.newImpediment = {
                impediments: this.impediment,
                projectId: this.projectId.value,
            };
            this.machineService.send({ type: "POST_IMPEDIMENT", payload: this.newImpediment });
        }
        ResolveImpediment(impedimentId) {
            this.send({ type: "RESOLVE_IMPEDIMENT", impedimentId: impedimentId });
        }
        showDeleteImpedimentModal(impedimentId) {
            this.impedimentId = impedimentId;
            this.machineService.send({ type: "DELETE_IMPEDIMENT" });
        }
        DeleteImpediment() {
            this.machineService.send({ type: "DELETING_IMPEDIMENT", impedimentId: this.impedimentId });
        }
        cancelImpediment() {
            this.machineService.send({ type: "CLOSE_MODAL" });
            this.impedimentId = "";
        }
        get impediments() {
            return ProjectModule.projectImpediments;
        }
        HandleScroll() {
            this.container2 = document.querySelector("#containerElement .simplebar-content-wrapper");
            this.container2.scrollTo({ top: this.container2.clientHeight + 1000, behavior: "smooth" });
        }
        created() {
            this.projectId = Guid.parse(this.$route.params.projectId);
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (this.state.matches("modalActive.loadedImpediments")) {
                    this.impediment = "";
                }
                if (this.state.matches("modalActive.loadedImpediments") && previousState.matches("modalActive.gettingImpediments")) {
                    this.HandleScroll();
                }
                if (this.state.matches("modalActive.loadedImpediments") && previousState.matches("modalActive.postImpediment")) {
                    ProjectModule.ImpedimentIncrementCount();
                    this.HandleScroll();
                }
                if (this.state.matches("modalActive.loadedImpediments") && previousState.matches("modalActive.resolveImpediment")) {
                    ProjectModule.ImpedimentDecrementCount();
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    ProjectImpedimentComponent = __decorate([
        Component({
            name: "projectImpedimentComponent",
            components: {
                simplebar,
                DeleteComponent,
                Loader,
            },
        })
    ], ProjectImpedimentComponent);
    return ProjectImpedimentComponent;
})();
export default ProjectImpedimentComponent;
